export const TABS_COUNT = 3;
export const ITEMS_COUNT = 4;
